export const DataHooks = {
  App: 'app-hook',
  PageHeader: 'pageHeader-hook',
  pageTitle: 'app.pageTitle-hook',
  SubtitleLearnMoreButton: 'app.subtitle.learn.more.button',
  Tabs: 'app-tabs-hook',
  Page: 'ccp-app-page-hook',
  PageBreadcrumbs: 'page.breadcrumbs-hook',
  PrivacyToolsPage: 'privacy-tools-page-hook',
  BannerSettingsPage: 'banner-settings-page-hook',
  PrivacyToolsDescription: 'privacy.tools.description-hook',
  PrivacyToolsTitle: 'privacy.tools.title-hook',
  VisitorData: 'visitor.data-hook',
  CookieConsentHeader: 'cookie.privacy.section-hook',
  UnpublishedStateContainer: 'unpublished-container',

  DrillInSectionContainer: 'drill-in-section.container',
  DrillInSectionHeader: 'drill-in-section.header',
  DrillInSectionDrill: 'drill-in-section.drill',

  SetupPrivacyContainer: 'setup-privacy-section-hook',
  SetupPrivacyHeader: 'setup-privacy-header-hook',
  SetupPrivacyMoreButton: 'setup-privacy-show-more-hook',
  SetupPrivacyLessButton: 'setup-privacy-show-less-hook',
  SetupPrivacyLearnMoreButton: 'setup-privacy-learn-more',
  SetupPrivacyLearnHowButton: 'setup-privacy-learn-how',
  SetupPrivacyFloatingNotification: 'setup-privacy-floating-notification',

  DoNotSellHeader: 'do.not.sell.section-hook',
  DisclaimerText: 'disclaimer.text-hook',
  SaveAndPublishButton: 'save.and.publish-hook',
  SaveMissingLinkModal: 'save-and-publish.prompt-modal',
  SaveMissingLinkPrompt: 'save-and-publish.prompt',
  SaveFailedModal: 'save.failed.prompt.modal',
  SaveFailedPrompt: 'save.failed.prompt.prompt',
  SaveSuccessModal: 'save.success.prompt.modal',
  SaveSuccessPrompt: 'save.success.prompt.prompt',
  SaveDisableModal: 'save-and-publish.disable.modal',
  SaveDisablePrompt: 'save-and-publish.disable.prompt',
  SectionButton: 'section.button-hook',
  SectionTooltip: 'section.tooltip-hook',
  SectionIconButton: 'section-icon-button-hook',
  ToggleCookieBannerContainer: 'toggle.cookie.banner.container-hook',
  ToggleCookieBanner: 'toggle.cookie.banner-hook',
  ToggleCookieBannerTitle: 'toggle.cookie.banner.title-hook',
  ToggleCookieBannerSubtitle: 'toggle.cookie.banner.subtitle-hook',

  StopNavigationModal: 'stop.navigation.modal',
  StopNavigationPrompt: 'stop.navigation.prompt',

  TextAndDisplayComponent: 'text-and-display.component',
  TextAndDisplayHeader: 'text-and-display.header',
  TextAndDisplayTheme: 'text-and-display.theme',
  TextAndDisplayConsent: 'text-and-display.consent',
  TextAndDisplaySetting: 'text-and-display.setting',
  TextAndDisplayPrivacy: 'text-and-display.privacy',
  TextAndDisplayPrivacyInfo: 'text-and-display.privacy-info',
  TextAndDisplayPrivacyRestore: 'text-and-display.privacy-restore',
  ThemePreviewContainer: 'text-and-display.theme-preview',

  ThemeBannerPreviewImageLight: 'theme-preview.banner.light',
  ThemeBannerPreviewImageDark: 'theme-preview.banner.dark',
  ThemePopupPreviewImageLight: 'theme-preview.popup.light',
  ThemePopupPreviewImageDark: 'theme-preview.popup.dark',

  PrivacyPolicyContainer: 'privacy-policy.container',
  PrivacyPolicyHeader: 'privacy-policy.header',
  PrivacyPolicyType: 'privacy-policy.type',
  PrivacyPolicyPage: 'privacy-policy.page',
  PrivacyPolicyUrl: 'privacy-policy.url',

  VisitorDataConsentLog: 'visitor-data-consent-log-hook',
  VisitorDataDataRequest: 'visitor-data-data-request-hook',
  VisitorDataDescription: 'visitor-data-description',

  AudienceContainer: 'audience.container',
  AudienceHeader: 'audience.header',
  AudienceVisitorField: 'audience.visitor.field',
  AudienceVisitorShowMore: 'audience.visitor.show-more',
  AudienceVisitorDropdown: 'audience.visitor.dropdown',

  AdvancedCardContainer: 'advanced-card.container',

  AdvancedPage: 'advanced.page',
  AdvancedCategoriesContainer: 'advanced.categories.container',
  AdvancedCategoriesHeader: 'advanced.categories.header',
  AdvancedCategoriesToggle: 'advanced.categories.toggle',
  AdvancedCategoriesSave: 'advanced.categories.save',
  AdvancedCategoriesTabs: 'advanced.categories.tabs',
  AdvancedCategoriesTab: 'advanced.categories.tab-',
  AdvancedEditorsContainer: 'advanced.editors.container',
  AdvancedEditorsTabHeadline: 'advanced.editors.tab.headline',
  AdvancedEditorsText: 'advanced.editors.tab.text',
  AdvancedEditorsParagraph: 'advanced.editors.tab.paragraph',
  AdvancedEditorsRestore: 'advanced.editors.tab.restore',

  ResetLogSection: 'reset-log.section',
  ResetLogModal: 'reset-log.modal',
  ResetLogPrompt: 'reset-log.prompt',

  ReviewCookiePolicyRequirementsContainer: 'review-cookie-policy-requirements-container',
  ReviewCookiePolicyRequirementsHeader: 'review-cookie-policy-requirements-header',
  ReviewCookiePolicyRequirementsDescription: 'review-cookie-policy-requirements-description',
  ReviewCookiePolicyRequirementsShowMore: 'review-cookie-policy-requirements-show-more',
  ReviewCookiePolicyRequirementsCheckbox: 'review-cookie-policy-requirements-checkbox',
};
